import React, { useEffect, useRef } from "react";
import { Container, Typography } from "@mui/material";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import Timeline from "../pages/Timeline";
import Brief from "../pages/Brief";
import Faqs from "../pages/Faqs";
import Reviews from "../pages/Reviews";
import Reviews2 from "../pages/Reviews2";
import Cosection from "../components/Cosections";
import Scrolltop from "../components/Scrolltop";
import WhatsAppChatButton from "../components/Whatsapp";
import "./Home.css";
import Carousel from "../pages/Carousel";
import Carousel1 from "../pages/Carousel1";
import Carousel2 from "../pages/Carousel2";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = ({ showQuoteModal, setShowQuoteModal }) => {
  const modalIntervalRef = useRef(null);
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    AOS.refresh();
  }, []);

  useEffect(() => {
    // Function to show modal only if not currently showing
    const showModalIfNotOpen = () => {
      if (!showQuoteModal) {
        setShowQuoteModal(true);
      }
    };

    // Start interval only if modal is not currently open
    if (!showQuoteModal) {
      modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000); // 2 minutes
    }

    return () => {
      // Clear interval on unmount
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
        modalIntervalRef.current = null;
      }
    };
  }, [showQuoteModal, setShowQuoteModal]);

  return (
    <>
      <Navigation />

      <div className="hero-section" data-aos="fade-up">
        <Container className="hero-content" maxWidth="md">
          <Typography variant="h2" fontWeight="bold">
            Your <span className="brand-highlight">All-in-One</span> Partner for Startup Success & Business Growth
          </Typography>
          <Typography variant="h5" className="subtitle">
            From seamless company registration and robust tax compliance to AI powered tools, MVP development, and data driven digital strategies. we provide everything you need to launch, scale, and grow your business.
          </Typography>
          <Typography variant="h4" className="subtitle" fontWeight="bold" sx={{ mt: 1 }}>
            Focus on your vision. We’ll handle the execution.
          </Typography>
        </Container>
      </div>

      {/* Rest of components */}
      <Brief />
      <Timeline />
      <Carousel />
      <Carousel1 />
      <Carousel2 />
      <Reviews />
      <Reviews2 />
      <Faqs />
      
      <Scrolltop />
      <WhatsAppChatButton />
      <Cosection setShowQuoteModal={setShowQuoteModal} />
      <Footer />
    </>
  );
};

export default Home;